import httpService from "./http-service";

export default {
  getConfiguration() {
    return httpService.get(`configurations`);
  },
  fetchCrmData(payload) {
    return httpService.get(`crm-data`, {
      params: {
        ...payload,
      },
    });
  },
};
